import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const auth = getAuth();

    try {
      await sendPasswordResetEmail(auth, email);
      setSnackbarMessage(
        "Password reset email has been sent to the email on file."
      );
      setSnackbarSeverity("success");
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        setSnackbarMessage("The email does not exist.");
        setSnackbarSeverity("error");
      } else {
        setSnackbarMessage("An error occurred. Please try again.");
        setSnackbarSeverity("error");
      }
    } finally {
      setEmail(""); // Clear the email field
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Card>
      <CardHeader
        title="Reset Password"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email Address"
            type="email"
            value={email}
            onChange={handleEmailChange}
            fullWidth
            required
            margin="normal"
          />
          <Button type="submit" variant="contained" color="primary">
            Send Password Reset Email
          </Button>
        </form>
      </CardContent>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default ResetPassword;
